export const endpoints = {
  GET_OPINIONS: '/api/opinions',
  CREATE_OPINION: '/api/opinions/:id',
  OPINION_I_GIVE: '/api/opinions/i-give',
  UPDATE_OPINION_STATUS: '/api/opinions/:id/status',
  GET_OPINIONS_AVERAGE: '/api/opinions/average',
  GET_PUBLIC_OPINIONS: '/api/public/opinions',
  CREATE_OPINION_CLAIM: '/api/opinions/:id/claim',
};
